// Defers heavy monitoring SDKs (Sentry ~186 KB, Mixpanel ~169 KB) until the
// user first interacts with the page, or after a short idle fallback. This
// keeps them out of the critical-path bundle and improves FCP/LCP.

import { initSentry } from "./sentry";
import { initGoogleAnalytics, initMixpanel } from "./analytics";

const IDLE_FALLBACK_MS = 4000;
const INTERACTION_EVENTS: Array<keyof WindowEventMap> = [
  "pointerdown",
  "keydown",
  "scroll",
  "touchstart",
];

let started = false;

const bootMonitoring = () => {
  if (started) return;
  started = true;

  // GA is lightweight — fire immediately on the first idle window.
  initGoogleAnalytics();

  // Mixpanel and Sentry are heavy — load asynchronously without blocking.
  initMixpanel();
  initSentry();
};

export const scheduleMonitoringBoot = () => {
  if (typeof window === "undefined") return;

  const onInteraction = () => {
    bootMonitoring();
    INTERACTION_EVENTS.forEach((evt) =>
      window.removeEventListener(evt, onInteraction, { capture: true } as any),
    );
  };

  INTERACTION_EVENTS.forEach((evt) =>
    window.addEventListener(evt, onInteraction, { capture: true, passive: true, once: true } as any),
  );

  // Idle fallback so monitoring still loads on pages without interaction.
  const ric: any = (window as any).requestIdleCallback;
  if (typeof ric === "function") {
    ric(() => bootMonitoring(), { timeout: IDLE_FALLBACK_MS });
  } else {
    window.setTimeout(bootMonitoring, IDLE_FALLBACK_MS);
  }
};
